/** Billing's own views, `/billing/<tab>`; the bare path redirects to the first. Invoices and credit notes join Receipts here. */
export const BILLING_TABS = ['receipts'] as const;
export type BillingTab = (typeof BILLING_TABS)[number];

export const BILLING_PATH = '/billing';

export function billingTabPath(tab: BillingTab): string {
  return `${BILLING_PATH}/${tab}`;
}

export function receiptPath(id: string): string {
  return `${billingTabPath('receipts')}/${id}`;
}
